import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse,
    HttpHeaders
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { SpinnerComponent, MessagesComponent } from 'src/common/components';
import { Auth } from '../security';
import { TranslationManager } from '../translation';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {

    constructor(private router: Router) { }
    translationManager = TranslationManager;
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (!request.url.toLowerCase().includes("widgets")) {
            SpinnerComponent.instance.show = true;
        }

        request = request.clone({
            setHeaders: {
                //cms_cat: environment.clientApplicationToken,
                translation_culture: TranslationManager.languages ? TranslationManager.languages.selectedLanguage : ''
            }
        });

        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    if (!request.url.toLowerCase().includes("widgets")) {
                        SpinnerComponent.instance.show = false;
                    }
                }
                return event;
            }),
            catchError((error: HttpErrorResponse) => {
                if (!request.url.toLowerCase().includes("widgets")) {
                    SpinnerComponent.instance.show = false;
                }
                if (error.status == 401 && error.statusText == 'Unauthorized') {
                    Auth.logOut();
                    this.router.navigate(['/unauthorized']);
                } else if (error.status == 403 && error.statusText == 'Forbidden') {
                    this.router.navigate(['/unauthorized']);
                } else if (error.status != 400 && error.error != undefined) {

                    let messages: string[] = [];

                    if (error.error.Messages != undefined) {
                        messages = error.error.Messages;
                    } else if (error.error.message != undefined) {
                        messages.push(error.error.message);
                    }
                    else {
                        messages = [];

                        if (error.status == 406) /* If status is NotAcceptable - case when CT RestServices return an exception, show different message that we be able to detect where the problem is */ {
                            messages.push(this.translationManager.getTranslation('Сервис није у могућности да прихвати Ваш захтев, јавите се техничкој подршци.'));
                        } else {
                            messages.push(this.translationManager.getTranslation('Сервис није у могућности да обради Ваш захтев, јавите се техничкој подршци.'));
                        }

                    }

                    MessagesComponent.instance.showError(messages);
                }

                return throwError(error);
            }));
    }
}
